<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <v-server-table url="" :columns="columns" :options="options" name="microtags" ref="microtags"
                            @loading="toggleLoading" @loaded="toggleLoading" @row-click="showMicrotag">
              <template slot="macrotag" slot-scope="props">
                <div>
                  {{ props.row.macrotag.data.macrotag }}
                </div>
              </template>
              <template slot="actions" slot-scope="props">
                <div>
                  <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </template>
            </v-server-table>
          </div>
          <!-- /.box-body -->
          <div class="overlay" v-show="loading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import microtagsApi from '../../api/microtags'

  export default {
    data () {
      return {
        columns: [
          'microtag', 'macrotag', 'actions'
        ],
        options: {
          sortable: [
            'microtag'
          ],
          requestFunction: function (query) {
            return microtagsApi.index(query)
          }
        },
        loading: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Microtags inseriti',
        createButton: {
          display: true,
          text: 'Nuovo microtag',
          to: 'microtag'
        }
      })
    },

    methods: {
      remove (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          microtagsApi.delete(id)
            .then((response) => {
              this.$refs.microtags.refresh()
              toastr.success('La microtag è stata rimossa correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      toggleLoading () {
        // this.loading = !this.loading
      },
      showMicrotag (row) {
        this.$router.push({name: 'microtagsShow', params: {id: row.row.id}})
      }
    }
  }
</script>

<style>
  tr {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/microtags/Index.vue